'use client';

import React, { useState } from 'react';
import {
    User,
    Mail,
    Phone,
    MapPin,
    Baby,
    CreditCard,
    ShieldCheck,
    Camera,
    Save,
    KeyRound,
    ChevronRight,
    Heart,
    Smartphone,
    School,
    GraduationCap
} from 'lucide-react';

export default function WalimuridProfilePage() {
    const [isEditing, setIsEditing] = useState(false);

    const profile = {
        name: 'Bpk. Sudirman Hartono',
        email: 'sudirman.h@gmail.com',
        phone: '+62 813 9988 7766',
        address: 'Perumahan Villa Indah Blok C-12, Pekanbaru',
        occupation: 'Wiraswasta',
        children: [
            { name: 'Ahmad Al-Fatih', school: 'SD Pekanbaru', grade: 'Kelas 4A', studentId: '2024098711' },
            { name: 'Siti Aminah', school: 'SMP Pekanbaru', grade: 'Kelas 8B', studentId: '2022011205' }
        ]
    };

    return (
        <div className="p-6 md:p-10 space-y-10 animate-in fade-in duration-500 font-sans pb-20">
            {/* Header Section */}
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                <div className="flex items-center gap-6">
                    <div className="relative group">
                        <div className="w-24 h-24 md:w-32 md:h-32 rounded-[2.5rem] bg-primary flex items-center justify-center text-white text-3xl md:text-5xl font-black shadow-2xl shadow-primary/30 border-4 border-surface overflow-hidden relative group-hover:bg-primary-dark transition-all duration-300">
                            SH
                            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center cursor-pointer">
                                <Camera className="w-8 h-8 text-white" />
                            </div>
                        </div>
                        <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-success border-4 border-surface rounded-full shadow-lg"></div>
                    </div>
                    <div>
                        <h1 className="text-3xl font-black text-foreground tracking-tight">{profile.name}</h1>
                        <p className="text-primary font-bold uppercase tracking-widest text-[10px] mt-1.5 flex items-center gap-2">
                            Walimurid / Orang Tua
                        </p>
                        <div className="flex flex-wrap items-center gap-3 mt-4">
                            <span className="px-4 py-1.5 bg-primary/10 text-primary text-[10px] font-black rounded-full border border-primary/20 uppercase tracking-widest">Premium Member</span>
                            <span className="px-4 py-1.5 bg-surface border border-border-main text-secondary text-[10px] font-black rounded-full shadow-sm">ID: WM-90210</span>
                        </div>
                    </div>
                </div>
                <button
                    onClick={() => setIsEditing(!isEditing)}
                    className={`flex items-center gap-3 px-8 py-4 rounded-[1.5rem] font-black text-xs uppercase tracking-widest transition-all shadow-xl ${isEditing
                            ? 'bg-surface border-2 border-border-main text-secondary hover:bg-muted'
                            : 'bg-primary text-white hover:bg-primary-dark shadow-primary/30 active:scale-95'
                        }`}
                >
                    {isEditing ? 'Batalkan' : <>Edit Profil <User className="w-4 h-4" /></>}
                </button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                {/* Main Profile Info */}
                <div className="lg:col-span-8 space-y-8">
                    <div className="bg-surface border border-border-main rounded-[3rem] p-10 shadow-sm relative overflow-hidden">
                        <div className="flex items-center gap-4 mb-10">
                            <div className="w-12 h-12 rounded-2xl bg-primary-soft flex items-center justify-center text-primary">
                                <User className="w-6 h-6" />
                            </div>
                            <h2 className="text-xl font-black text-foreground">Data Pribadi Orang Tua</h2>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                            <div className="space-y-3">
                                <label className="text-[10px] font-black text-muted uppercase tracking-[0.2em] ml-1 flex items-center gap-2">Nama Lengkap</label>
                                <input
                                    type="text"
                                    defaultValue={profile.name}
                                    disabled={!isEditing}
                                    className="w-full bg-background/50 border-2 border-border-main rounded-2xl py-4 px-6 text-sm font-bold focus:ring-8 focus:ring-primary/5 focus:border-primary outline-none transition-all disabled:opacity-60 disabled:bg-muted/30"
                                />
                            </div>
                            <div className="space-y-3">
                                <label className="text-[10px] font-black text-muted uppercase tracking-[0.2em] ml-1 flex items-center gap-2">Email Address</label>
                                <input
                                    type="email"
                                    defaultValue={profile.email}
                                    disabled={!isEditing}
                                    className="w-full bg-background/50 border-2 border-border-main rounded-2xl py-4 px-6 text-sm font-bold focus:ring-8 focus:ring-primary/5 focus:border-primary outline-none transition-all disabled:opacity-60 disabled:bg-muted/30"
                                />
                            </div>
                            <div className="space-y-3">
                                <label className="text-[10px] font-black text-muted uppercase tracking-[0.2em] ml-1 flex items-center gap-2">Nomor WhatsApp</label>
                                <div className="relative group">
                                    <Smartphone className="absolute left-5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted group-focus-within:text-primary transition-colors" />
                                    <input
                                        type="text"
                                        defaultValue={profile.phone}
                                        disabled={!isEditing}
                                        className="w-full bg-background/50 border-2 border-border-main rounded-2xl py-4 pl-14 pr-6 text-sm font-bold focus:ring-8 focus:ring-primary/5 focus:border-primary outline-none transition-all disabled:opacity-60 disabled:bg-muted/30"
                                    />
                                </div>
                            </div>
                            <div className="space-y-3">
                                <label className="text-[10px] font-black text-muted uppercase tracking-[0.2em] ml-1 flex items-center gap-2">Pekerjaan</label>
                                <input
                                    type="text"
                                    defaultValue={profile.occupation}
                                    disabled={!isEditing}
                                    className="w-full bg-background/50 border-2 border-border-main rounded-2xl py-4 px-6 text-sm font-bold focus:ring-8 focus:ring-primary/5 focus:border-primary outline-none transition-all disabled:opacity-60 disabled:bg-muted/30"
                                />
                            </div>
                            <div className="md:col-span-2 space-y-3">
                                <label className="text-[10px] font-black text-muted uppercase tracking-[0.2em] ml-1 flex items-center gap-2">Alamat Lengkap</label>
                                <textarea
                                    defaultValue={profile.address}
                                    disabled={!isEditing}
                                    rows={3}
                                    className="w-full bg-background/50 border-2 border-border-main rounded-2xl py-4 px-6 text-sm font-bold focus:ring-8 focus:ring-primary/5 focus:border-primary outline-none transition-all disabled:opacity-60 disabled:bg-muted/30 resize-none"
                                />
                            </div>
                        </div>

                        {isEditing && (
                            <div className="mt-12 flex justify-end">
                                <button className="flex items-center gap-3 px-12 py-5 bg-primary text-white rounded-[2rem] font-black text-xs uppercase tracking-widest hover:bg-primary-dark transition-all shadow-2xl shadow-primary/30 animate-in zoom-in-95 duration-300">
                                    Simpan Perubahan <Save className="w-5 h-5" />
                                </button>
                            </div>
                        )}

                        <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full -mr-16 -mt-16 blur-3xl"></div>
                    </div>
                </div>

                {/* Sidebar Walimurid: Children & Security */}
                <div className="lg:col-span-4 space-y-8">
                    {/* Children List Card */}
                    <div className="bg-surface border border-border-main rounded-[3rem] p-8 shadow-sm">
                        <div className="flex items-center gap-3 mb-8">
                            <div className="w-10 h-10 rounded-2xl bg-primary-soft flex items-center justify-center text-primary">
                                <Baby className="w-5 h-5" />
                            </div>
                            <h2 className="text-lg font-black text-foreground">Data Anak</h2>
                        </div>

                        <div className="space-y-4">
                            {profile.children.map((child, idx) => (
                                <div key={idx} className="p-5 rounded-3xl bg-background border border-border-main/50 flex flex-col gap-4 group hover:border-primary transition-all cursor-pointer">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 rounded-2xl bg-primary-soft flex items-center justify-center text-lg font-black text-primary group-hover:bg-primary group-hover:text-white transition-all">
                                            {child.name.charAt(0)}
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className="text-sm font-black text-foreground truncate">{child.name}</p>
                                            <p className="text-[10px] font-bold text-muted truncate">{child.studentId}</p>
                                        </div>
                                        <ChevronRight className="w-4 h-4 text-muted group-hover:text-primary transition-colors" />
                                    </div>
                                    <div className="grid grid-cols-2 gap-2 pt-3 border-t border-border-main/50">
                                        <div className="flex flex-col">
                                            <span className="text-[8px] font-black text-muted uppercase tracking-widest">Sekolah</span>
                                            <span className="text-[10px] font-bold text-foreground line-clamp-1">{child.school}</span>
                                        </div>
                                        <div className="flex flex-col">
                                            <span className="text-[8px] font-black text-muted uppercase tracking-widest">Kelas</span>
                                            <span className="text-[10px] font-bold text-foreground truncate">{child.grade}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <button className="w-full py-4 px-6 border-2 border-dashed border-border-main rounded-3xl text-[10px] font-black uppercase tracking-widest text-muted hover:border-primary/50 hover:text-primary transition-all">
                                + Tambah Data Anak
                            </button>
                        </div>
                    </div>

                    {/* Quick Settings */}
                    <div className="bg-linear-to-br from-primary to-primary-dark rounded-[3rem] p-8 text-white shadow-2xl shadow-primary/20 relative overflow-hidden group">
                        <div className="relative z-10">
                            <div className="flex items-center gap-3 mb-6">
                                <KeyRound className="w-5 h-5 opacity-70" />
                                <h3 className="text-lg font-black">Kata Sandi</h3>
                            </div>
                            <p className="text-xs text-white/70 font-medium mb-8 leading-relaxed">Terakhir diubah: 3 bulan yang lalu. Pastikan password Anda kuat dan unik.</p>
                            <button className="w-full py-4 bg-white/20 hover:bg-white/30 backdrop-blur-md rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all mb-4">Ubah Password</button>
                        </div>
                        <Heart className="absolute -right-8 -bottom-8 w-40 h-40 opacity-10 group-hover:scale-110 transition-transform duration-500" />
                    </div>
                </div>
            </div>
        </div>
    );
}
